module.exports = __webpack_public_path__ + "img/next-mobile.be679b97.svg";